// Implements: F-UIX-015
/**
 * The platform locale: the one locale every date, number and money formatter of the interface
 * names (7.S12b-4.6, UIX.9), whatever the browser's.
 *
 * The copy is neutral Spanish, so the figures inside it are written in Spanish too: an English
 * browser must never read "$1,000.50", "Oct 13, 2026", "3:00 PM" or "2,150" inside a Spanish
 * sentence. Peruvian Spanish (`es-PE`) because amounts are typed with a decimal POINT in the
 * distribution and ceiling editors, and its money ("USD 1,000.50") reads back exactly as typed;
 * plain `es` writes "1000,50 US$", a decimal comma the editors refuse as ambiguous.
 *
 * Two options complete it, each named once here:
 * - `PLATFORM_HOUR_CYCLE`: times on the 24-hour clock ("15:00"), as `es` wrote them before
 *   (S12b-3); `es-PE` alone writes "3:00 p. m.".
 * - `PLATFORM_COUNT_GROUPING`: a count of four digits is not grouped ("2150"), as Spanish
 *   orthography writes it; five and more are ("21,500"). Money keeps the locale's grouping: it
 *   always carries a decimal point, so its comma can only be a thousands separator.
 *
 * Collation names the same locale, so "Ñandú" sorts after "Nzeta".
 */

export const PLATFORM_LOCALE = "es-PE";

export const PLATFORM_HOUR_CYCLE = "h23";

export const PLATFORM_COUNT_GROUPING = "min2";
